<template>
    <Head title="Create New Model" />
    <BreezeAuthenticatedLayout>
        <template #header>
            <h2 class="font-semibold text-xl leading-tight">
                Create New Page
            </h2>
        </template>
        <BreadCrumbs :items="navItems"></BreadCrumbs>
        <div class="w-full my-6 overflow-hidden py-12 shadow">
            <div class="px-6 pt-4 pb-2">
                <form @submit.prevent="create.post(requestUrl, { preserveScroll: true})" class="w-full">
                    <div class="grid md:grid-cols-2 gap-4">
                        <div class="mb-6 md:mb-4">
                            <admin-app-label>Name</admin-app-label>
                            <input-basic
                                placeholder="Name"
                                v-model="create.name"
                                :error="errors['name']"
                            />
                            <input-error v-if="errors['name']">
                                {{ errors.name }}
                            </input-error>
                        </div>
                        <div class="mb-6 md:mb-4">
                            <admin-app-label>Slug <small>(Optional)</small></admin-app-label>
                            <input-basic
                                placeholder="Slug"
                                v-model="create.slug"
                                :error="errors['slug']"
                            />
                            <input-error v-if="errors['slug']">
                                {{ errors.slug }}
                            </input-error>
                        </div>
                    </div>
                    <div class="mb-6 md:mb-4">
                        <admin-app-label>Description</admin-app-label>
                        <input-wysiwyg
                            v-model="create.description"
                        ></input-wysiwyg>
                        <input-error v-if="errors['description']">
                            {{ errors.description }}
                        </input-error>
                    </div>
                    <div class="grid md:grid-cols-2 gap-4">
                        <div class="mb-6 md:mb-4">
                            <admin-app-label>CTA Text</admin-app-label>
                            <input-basic
                                placeholder="CTA Text"
                                v-model="create.cta_text"
                                :error="errors['cta_text']"
                            />
                            <input-error v-if="errors['name']">
                                {{ errors.cta_text }}
                            </input-error>
                        </div>
                        <div class="mb-6 md:mb-4">
                            <admin-app-label>CTA Link</admin-app-label>
                            <input-basic
                                placeholder="CTA Link"
                                v-model="create.cta_link"
                                :error="errors['cta_link']"
                            />
                            <input-error v-if="errors['cta_link']">
                                {{ errors.cta_link }}
                            </input-error>
                        </div>
                    </div>
                    <div class="grid md:grid-cols-3 gap-4">
                        <div class="mb-6 md:mb-4">
                            <admin-app-label>Season</admin-app-label>
                            <input-select
                                placeholder="Season"
                                :options="seasons"
                                v-model="create.season"
                                :error="errors['season']"
                                label="name"
                            />
                            <input-error v-if="errors['season']">
                                {{ errors.season }}
                            </input-error>
                        </div>
                        <div class="mb-6 md:mb-4">
                            <admin-app-label>Vehicle Type</admin-app-label>
                            <input-select
                                placeholder="Vehicle Type"
                                :options="vehicleTypes"
                                v-model="create.vehicle_type"
                                :error="errors['vehicle_type']"
                                label="name"
                            />
                            <input-error v-if="errors['vehicle_type']">
                                {{ errors.vehicle_type }}
                            </input-error>
                        </div>
                        <div class="mb-6 md:mb-4">
                            <admin-app-label>Specialist Type</admin-app-label>
                            <input-select
                                placeholder="Specialist Type"
                                :options="specialistTypes"
                                v-model="create.specialist"
                                :error="errors['specialist']"
                                label="name"
                            />
                            <input-error v-if="errors['specialist']">
                                {{ errors.specialist }}
                            </input-error>
                        </div>
                    </div>

                    <add-videos v-model="create.videos" :errors="errors"></add-videos>
                    <seo-tags v-model="create.seo_tags" :errors="errors"></seo-tags>
                    <app-button type="submit" class="mt-8">Create</app-button>
                </form>
            </div>
        </div>
    </BreezeAuthenticatedLayout>
</template>

<script>
import {useForm} from "@inertiajs/inertia-vue3";
import BreezeAuthenticatedLayout from "@/Layouts/Admin/Authenticated.vue";
import {Head} from "@inertiajs/inertia-vue3";
import Label from "@/Components/Label";
import InputBasic from "@/Components/Admin/Forms/Inputs/InputBasic";
import AppButton from "@/Components/AppButton";
import InputError from "@/Components/Forms/Inputs/InputError";
import AdminAppLabel from "@/Components/Admin/Forms/AdminAppLabel";
import InputSelect from "@/Components/Admin/Forms/Inputs/InputSelect";
import InputWysiwyg from "@/Components/Admin/Forms/Inputs/InputWysiwyg";
import BreadCrumbs from "@/Components/Admin/BreadCrumbs";
import ImageUpload from "@/Components/Admin/Forms/Inputs/ImageUpload";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import SeoTags from "@/Components/Admin/Forms/SeoTags";
import AddVideos from "@/Components/Admin/Forms/AddVideos";

export default {
    name: "Create",
    components: {
        AddVideos,
        SeoTags,
        BreadCrumbs,
        InputWysiwyg,
        ImageUpload,
        InputSelect,
        AdminAppLabel,
        AppButton,
        InputBasic,
        Label,
        FontAwesomeIcon,
        BreezeAuthenticatedLayout,
        Head,
        InputError
    },
    props: {
        name: String,
        errors: Object,
        seasons: Object,
        vehicleTypes: Object,
        specialistTypes: Object,
        requestUrl: {
            type: String,
            default: '/admin/pages'
        }
    },
    data() {
        return {
            navItems: [
                { title: 'Pages', path: '/admin/pages'},
                { title: 'Create New', path: '/admin/pages/create'}
            ],
            create: useForm(
                {
                    name: "",
                    slug: "",
                    description: "",
                    cta_text: "",
                    cta_link: "",
                    season: null,
                    vehicle_type: null,
                    specialist: null,
                    videos: [],
                    seo_tags: null
                }
            )
        }
    },
    methods: {
    }
}
</script>

<style scoped>

</style>
